export default {
    "Lone Working Violence": "lon_haz_lev",
    "Plant and equipment": "pla_haz_lev",
    "Biological Agents": "bio_age_haz_lev",
    "Demolition Method": "dem_haz_lev",
    "Falls & Falling Objects": "fal_fal_haz_lev",
    Services: "ser_haz_lev",
    "Working Close To Water": "wor_clo_to_wat_haz_lev",
    Substances: "sub_haz_lev",
    Asbestos: "asb_haz_lev",
    "Confined Space": "con_spa_haz_lev",
    "General / Other Items": "gen_haz_lev",
    "Manual Handling": "man_han_haz_lev",
    "Health Assess": "hea_haz_lev",
    "Roof Work & Roof Space": "roo_wor_haz_lev",
    "Upper Floor": "upp_flo_haz_lev",
    "In-Situ": "insitu_haz_lev",
    "Pre-Cast": "pre_cast_haz_lev",
    "Steel Workings": "ste_wor_haz_lev",
    "Harmful Gases": "ham_gas_haz_lev",
    "Rock Blasting": "roc_bla_haz_lev",
    Fire: "fir_haz_lev",
    Infestation: "inf_haz_lev",
    Dusting: "dus_haz_lev",
    Excavation: "exc_haz_lev",
    "Hand Tools": "han_haz_lev",
    "Working close to public": "wcp_haz_lev",
    Traffic: "tra_haz_lev",
    PPE: "ppe_haz_lev",
    Supervision: "sup_haz_lev",
    "Ground Floor": "gro_flo_haz_lev",
    "Covid-19 Measures": "cov_haz_lev"
};
